import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import StationMap from "../../components/StationMap";
import { StatusPill } from "../../components/Pills";
import { useNavigate } from "react-router-dom";
import { Battery, Zap } from "lucide-react";

export default function ConsumerStations() {
  const [stations, setStations] = useState([]);
  const [selected, setSelected] = useState(null);
  const [emergency, setEmergency] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/stations").then(({ data }) => setStations(data));
    api.get("/emergency").then(({ data }) => setEmergency(data.active));
  }, []);

  return (
    <div className="p-6 lg:p-8">
      <div className="mb-6">
        <div className="bin-label">DISCOVER</div>
        <h1 className="text-3xl font-black tracking-tighter mt-1">Nearby Stations</h1>
        <p className="text-sm text-zinc-500 mt-2">Tap a node to inspect or request power.</p>
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <StationMap stations={stations} selectedId={selected?.id} onSelect={setSelected} emergency={emergency} />
        </div>

        <div className="space-y-3 max-h-[480px] overflow-auto">
          {stations.map((s) => (
            <button
              key={s.id}
              data-testid={`station-card-${s.id}`}
              onClick={() => navigate(`/app/consumer/stations/${s.id}`)}
              className="w-full text-left bin-card p-4 hover:border-cyan-500/50 transition-colors"
            >
              <div className="flex items-center justify-between mb-2">
                <div className="font-bold">{s.name}</div>
                <StatusPill status={s.status} />
              </div>
              <div className="text-xs text-zinc-500 mb-3 font-mono">{s.address}</div>
              <div className="flex items-center gap-4 text-xs">
                <span className="flex items-center gap-1 text-zinc-400">
                  <Battery className="w-3 h-3 text-emerald-400" />
                  <span className="font-mono">{Math.round((s.battery_kwh / s.battery_max_kwh) * 100)}%</span>
                </span>
                <span className="flex items-center gap-1 text-zinc-400">
                  <Zap className="w-3 h-3 text-cyan-400" />
                  <span className="font-mono">{s.capacity_kw}kW</span>
                </span>
                <span className="text-zinc-500 font-mono uppercase">{s.power_source}</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
